// extracted by mini-css-extract-plugin
module.exports = {"CardLink":"nav-item_CardLink___AXZT","MenuItem":"nav-item_MenuItem__cJc3v","Anchor":"nav-item_Anchor__UgIbO"};